import {
  Typography,
  Button,
  TextField,
  Divider,
  CircularProgress,
  Box,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import PasswordVisibility from "../PasswordVisibility";
import RoleCard from "./RoleCard";
import OtpTimer from "./OtpTimer";
import { useState } from "react";

const PasswordStep = ({
  selectedRole,
  password,
  showPassword,
  loading,
  onPasswordChange,
  onTogglePasswordVisibility,
  onTogglePassword,
  onBack,
  onOtpLogin,
  isOtpMode,
  otp,
  onOtpChange,
  onOtpExpire,
  t,
}) => {
  const [timerKey, setTimerKey] = useState(0);

  const handleResendOtp = () => {
    onOtpLogin();
    setTimerKey(timerKey + 1);
  };
  return (
    <>
      {!isOtpMode ? (
        <Typography variant="h6" align="center" mb={2}>
          {t("Enter your password")}
        </Typography>
      ) : (
        <Typography variant="h6" align="center" mb={2}>
          {t("Enter the OTP")}
        </Typography>
      )}

      {/* Selected role card */}
      <div style={{ marginBottom: "16px" }}>
        {selectedRole && (
          <RoleCard
            roleData={selectedRole}
            index="selected"
            isSelected={true}
            isInteractive={false}
          />
        )}
      </div>

      <Divider sx={{ my: 2 }} />

      {!isOtpMode ? (
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="password"
          label={t("Password")}
          type={showPassword ? "text" : "password"}
          id="password"
          autoComplete="current-password"
          value={password}
          onChange={onPasswordChange}
          InputProps={{
            endAdornment: (
              <PasswordVisibility
                showPassword={showPassword}
                setShowPassword={onTogglePasswordVisibility}
              />
            ),
          }}
        />
      ) : (
        <>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="otp"
            label={t("Enter OTP")}
            type="text"
            id="otp"
            autoComplete="off"
            value={otp}
            onChange={(e) => onOtpChange(e.target.value)}
            disabled={loading}
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: 2,
            }}
          >
            <OtpTimer
              key={timerKey}
              duration={600}
              onExpire={() => {
                onOtpExpire?.();
              }}
              t={t}
            />
            <Button
              onClick={handleResendOtp}
              size="small"
              sx={{ mt: 1 }}
              disabled={loading}
            >
              {t("Resend OTP")}
            </Button>
          </Box>
        </>
      )}

      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        sx={{ mt: 2, color: "white" }}
        disabled={loading}
      >
        {loading ? (
          <CircularProgress size={28} style={{ color: "white" }} />
        ) : (
          t("Login")
        )}
      </Button>

      <Button
        onClick={isOtpMode ? onTogglePassword : onOtpLogin}
        fullWidth
        variant="outlined"
        color="primary"
        disabled={loading}
        sx={{ mt: 3 }}
      >
        {isOtpMode ? t("Login with Password") : t("Login with OTP")}
      </Button>

      <Button
        startIcon={<ArrowBack />}
        onClick={onBack}
        sx={{ mt: 2 }}
        fullWidth
      >
        {t("Back to role selection")}
      </Button>
    </>
  );
};

export default PasswordStep;
